var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Group","stroke":"inherit","strokeWidth":"40","transform":"translate(20 20)"},[React.createElement("path",{"id":"Path","strokeLinejoin":"round","d":"M230.8 333.7L131 234l99.8 99.7.1-205.7.2.3.1 205.7 99.8-99.7-99.8 99.7","key":0}),React.createElement("circle",{"id":"Oval","cx":"230.5","cy":"230.5","r":"230.5","key":1})])));
}

Arrow.defaultProps = {"viewBox":"0 0 501 501"};

module.exports = Arrow;

Arrow.default = Arrow;
